import sprintf from 'sprintf'
import jQuery from 'jquery'
import spinner from 'components/ui/Spinner'

(function($){
  
  $.fn.startLoading = function(options) {
    options = options || {};
    options.strokeWidth = options.strokeWidth || 4;
    options.color = options.color || "#76cce8";
    options.radius = options.radius || 20;
    options.modalOpacity = options.modalOpacity == 0 ? 0 : 0.6;
    options.modalBackgroundColor = options.modalBackgroundColor || "#ffffff";
    
    this.each(function(){
      var $container = $(this);
      $container.css({position: "relative"});
      var $wrapper = $container.find(".js-modal-wrapper");
      if ($wrapper.length != 0) {
        $wrapper.remove();
      } else {
        $container.append('<div class="js-modal-wrapper" />');
        $wrapper = $container.find('.js-modal-wrapper');
      }
      
      $wrapper.append('<div class="js-modal" />');
      var $modal = $wrapper.find('.js-modal');
      $wrapper.append('<div class="js-spinner"></div>');
      var $spinner = $wrapper.find('.js-spinner');
      
      if (this.tagName.toLowerCase() == 'body') {
        $wrapper.css({position: "fixed", width: "100%", height: "100%"});
      } else {
        $wrapper.width($container.outerWidth()).height($container.outerHeight());
      }
      $modal.css({
        backgroundColor: hexColorToRGBA(
          options.modalBackgroundColor,
          options.modalOpacity
        ),
      });
      $spinner.
        css({
          margin: 0,
          position: "absolute",
          top: $modal.outerHeight() / 2 - options.radius,
          left: $modal.outerWidth() / 2 - options.radius,
        }).
        materialSpinner({
          strokeWidth: options.strokeWidth,
          radius: options.radius,
          color: options.color
        });
    });
    
    return this;
  };
  
  var hexColorToRGBA = function(c, opacity){
    c = c.replace("#","");
    var r = parseInt(c.substring(0,2), 16),
        g = parseInt(c.substring(2,4), 16),
        b = parseInt(c.substring(4,6), 16);
    return sprintf("rgba(%d,%d,%d,%f)", r, g, b, opacity);
  };
  
  $.fn.stopLoading = function() {
    this.each(function(){
      $(this).find(".js-modal-wrapper").remove();
    });
    return this;
  };
})(jQuery);



// WEBPACK FOOTER //
// ./app/javascript/plugins/loading.js